import { render, staticRenderFns } from "./ViewFor.vue?vue&type=template&id=783d3f70&"
import script from "./ViewFor.vue?vue&type=script&lang=js&"
export * from "./ViewFor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ViewFor.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml&locale=en"
if (typeof block0 === 'function') block0(component)

export default component.exports